module.exports = __webpack_public_path__ + "img/icon-data-diet-active.fc7cf52c.svg";